module.exports = __webpack_public_path__ + "static/media/Logo_FESTApora.dceff6a8.png";